module.exports = __webpack_public_path__ + "static/img/h_2_23.f308588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h_2_23.png
// module id = K2l9
// module chunks = 0